"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "outdatedBrowserInfo", {
    enumerable: true,
    get: function get() {
        return _utils.outdatedBrowserInfo;
    }
});
var _utils = require("./utils"); //# sourceMappingURL=index.js.map
